export default __webpack_public_path__ + "static/shop-pay-affirm-logo-white-684c0c4030d1fa8d7dca26f286475677.png";